import React, { Component } from 'react';

import Alert from './global/Alert';
import AdminRoutes from './routing/Routes';

class Main extends Component {
    render() {
        return (
            <main className="app-content">
                <div className="content-wrapper">
                    <Alert />
                    <AdminRoutes />
                </div>
            </main>
        );
    }
}

export default Main;